import { render, staticRenderFns } from "./footer-minimal.vue?vue&type=template&id=ced30756"
var script = {}
import style0 from "./footer-minimal.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports